<template>
  <v-layout
    wrap
  >
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="card"
      :tile="true"
      class="mx-auto"
      width="100%"
    />
    <v-flex
      v-if="!$apollo.loading && aumPerProjectSeries"
    >
      <center>
        <pie-chart
          ref="chart"
          :chartdata="chartData"
          :chartoptions="chartOptions"
          :styles="ChartStyles"
        />
      </center>
    </v-flex>
    <v-flex 
      v-if="!$apollo.loading && !aumPerProjectSeries"
      class="not-found"
    >
      <v-icon>mdi-ghost</v-icon>
      <p>{{ $t('traderdashboard.projectsNotFound') }}</p>
    </v-flex>
  </v-layout>  
</template>


<script>
import PieChart  from '@/charts/Pie.vue'
import { setTimeout } from 'timers';

const AUM_PER_PROJECT_SERIES_QUERY = require('@/graphql/queries/AumPerProjectSeries.gql');

const COLORS = ['#0436af', '#007ED6', '#52D726', '#FF7300',  '#FFEC00', '#FF0000', '#7CDDDD', '#b7ded2', '#f6a6b2', '#f7c297', '#ffecb8']

export default {
  components: { 
    PieChart 
  },
  data() {
    return {
      name: 'AumPerProjectPie',
      loading: false
    }
  },
  computed: {
    ChartStyles() {
      return {
        height: `250px`,
        width: `320px`,
        position: `relative`
      }
    },
    chartData() {
      return {
        labels: this.aumPerProjectSeries.labels,
        datasets: [{
          label: 'Label',
          data: this.aumPerProjectSeries.datasets,
          aum: this.aumPerProjectSeries.aum,
          backgroundColor: this.randomColor(this.aumPerProjectSeries.datasets)
        }]
      }
    },
    chartOptions() {
      return {
        cutoutPercentage: 55,
        legend: {
            display: true,
            position: 'bottom',
            fullWidth: false,
            labels: {
                fontColor: 'rgb(255, 99, 132)',
                fontSize: 11,
                boxWidth: 10
            }
        },
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              let indice = tooltipItem.index
              return  data.datasets[0].aum[indice] + ' BTC (' + data.datasets[0].data[indice] + '%)'
            },
            title: function(tooltipItem, data) {
              var indice = tooltipItem[0].index  
              return  data.labels[indice]
            }
          }
        },
      } 
    }
  },
  methods: {
    randomColor(values) {
      let colors = []
      values.forEach((item, index) => {
        colors.push(COLORS[index])
      })  
      return colors
    }
  },
  apollo: {
    aumPerProjectSeries: {
      query: AUM_PER_PROJECT_SERIES_QUERY,
    },
  }
};
</script>

<style lang="scss">

</style>
